import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SkillPathCard = ({ path, onExplore }) => {
  const getIconColor = (category) => {
    switch (category) {
      case 'Leadership':
        return 'text-purple-600 bg-purple-100 dark:bg-purple-900/30';
      case 'Technical':
        return 'text-blue-600 bg-blue-100 dark:bg-blue-900/30';
      case 'Communication':
        return 'text-green-600 bg-green-100 dark:bg-green-900/30';
      case 'Management':
        return 'text-orange-600 bg-orange-100 dark:bg-orange-900/30';
      default:
        return 'text-gray-600 bg-gray-100 dark:bg-gray-800';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-all duration-300">
      <div className="flex items-start gap-4 mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getIconColor(path?.category)}`}>
          <Icon name={path?.icon} size={24} />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-1">{path?.title}</h3>
          <p className="text-sm text-muted-foreground">{path?.description}</p>
        </div>
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Courses</span>
          <span className="font-semibold text-foreground">{path?.courses}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Total Duration</span>
          <span className="font-semibold text-foreground">{path?.totalDuration}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Skill Level</span>
          <span className="font-semibold text-foreground">{path?.skillLevel}</span>
        </div>
      </div>
      <div className="mb-4">
        <div className="flex items-center justify-between text-xs text-muted-foreground mb-2">
          <span>Completion</span>
          <span>{path?.completion}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ width: `${path?.completion}%` }}
          />
        </div>
      </div>
      <Button
        variant="outline"
        fullWidth
        onClick={() => onExplore(path)}
        iconName="ArrowRight"
        iconPosition="right"
      >
        Explore Path
      </Button>
    </div>
  );
};

export default SkillPathCard;